import Icons, { IconsProps } from '../../Icons';

export type MyLocationProps = IconsProps;

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/

export function MyLocation(props: MyLocationProps) {
  return (
    <Icons {...props}>
      <path d="M11.5 21.45V20c-2.083-.2-3.804-.979-5.162-2.337C4.979 16.304 4.2 14.583 4 12.5H2.55v-1H4c.2-2.083.98-3.804 2.338-5.163C7.696 4.979 9.417 4.2 11.5 4V2.55h1V4c2.083.2 3.804.979 5.163 2.337C19.021 7.696 19.8 9.417 20 11.5h1.45v1H20c-.2 2.083-.979 3.804-2.337 5.163C16.304 19.021 14.583 19.8 12.5 20v1.45h-1ZM12 19c1.933 0 3.583-.683 4.95-2.05C18.317 15.583 19 13.933 19 12c0-1.933-.683-3.583-2.05-4.95C15.583 5.683 13.933 5 12 5c-1.933 0-3.583.683-4.95 2.05C5.683 8.417 5 10.067 5 12c0 1.933.683 3.583 2.05 4.95C8.417 18.317 10.067 19 12 19Zm0-4a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 9 12c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 12 9c.833 0 1.542.292 2.125.875S15 11.167 15 12s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 12 15Z" />
    </Icons>
  );
}
